import React, {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import '../../../../../App.css'
import { checkMobileNoValid } from '../../../../../data/config'
import useMutationApi from '../../../../../hooks/useMutation'
import { MPIN_RESET_OTP } from '../../../GraphQLQuries/Auth'
import { useDispatch } from 'react-redux'
import { actionsUsers } from '../../../../../setup/redux/rootReducer'
import { LoadingSpinner } from '../../../../../_ePulse/layout/components/LoadingSpinner'

const initialValues = {
  countryCode: 91,
  mobileNumber: ''
}


const loginSchema = Yup.object().shape({
  // mobileNumber: Yup.number().required('Phone Number is required'),
  mobileNumber: Yup.string()
    .required('Phone Number is required')
    .matches(/^\d+$/, 'Phone Number must only contain digits')
    .test('is-valid-number', 'Phone Number must be a valid number', (value) => {
      if (!value) return false // Required check
      return !isNaN(Number(value)) // Ensure it's a valid number
    }),
  countryCode: Yup.number().required('Country is required').not(['default'], 'Select Country Code'),
})


export function ForgotMpin() {
  const navigate = useNavigate();
  const location = useLocation();
  const {mpinLength, resendOtpTime }: any= location.state;
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)


  const {createData, data, error} = useMutationApi(MPIN_RESET_OTP)
  const dispatch = useDispatch()

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values) => {
      setLoading(true)
      setHasErrors(undefined)
      try {
        setLoading(true);
        const mobileNumber = values.mobileNumber.toString()
        const countryCode = values.countryCode;
        const res = await createData({
            sendOtpInput:{
                mobileNumber,
                countryCode: countryCode,
            }
        })
        if (process.env.REACT_APP_ENV !== 'PROD') {
          //OTP TOAST
          alert(res?.data?.sendResetMpinOtp)
        }
        dispatch(
          actionsUsers.updateUser({
            mobile_number: formik.values.mobileNumber,
          })
        )

        // navigate to enter pin screen
        navigate(`/auth/reset-password`, {
          state: { mobileNumber, mpinLength, countryCode, resendOtpTime},
        })
        setLoading(false)
      } catch (error: any) {
        setHasErrors(true);
        // setSubmitting(false)
        setLoading(false)
        console.log(error);
      }
    },
  })

const changeMobileNo = (value: any) => {
    const valid = checkMobileNoValid(value)
    if (valid) {
    formik.setFieldValue('mobileNumber', parseInt(value))
    }
}
  return (
    <>
      <LoadingSpinner isLoading={loading} />

      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h1 className='text-dark mb-3'>
            Reset MPIN?
          </h1>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-400 fw-bold fs-4'>No worries, we’ll help you reset</div>
          {/* end::Link */}
        </div>

        {/* begin::Title */}
        {hasErrors === true && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>
              Sorry, looks like there are some errors detected, please try again.
            </div>
          </div>
        )}

        {/* end::Title */}

        {/* begin::Form group */}
        <div className='fv-row mb-10'>
          <div className='d-flex flex-row form-control'>
            <select
              className=' border-0'
              value={formik.values.countryCode}
              onChange={(e) => {
                formik.setFieldValue('countryCode', e.target.value)
              }}
              // {...formik.getFieldProps('countryCode')}
            >
              {/* {countryCode?.map((item: any) => {
              return (
                <option key={item.id} value={item.phoneCode}>
                +{item.phoneCode}
                </option>
                )
                })} */}

              <option key={'India'} value={91}>
                +91
              </option>
            </select>
            <input
              placeholder='Phone Number'
              className={clsx('form-control border-0')}
              value={formik.values.mobileNumber}
              type={'number'}
              onWheel={(e) => {
                e.preventDefault() // Prevent mouse wheel and touchpad scrolling
              }}
              // Disable scrolling when focused
              onFocus={(e) => e.target.addEventListener('wheel', (e) => e.preventDefault())}
              onChange={(e: any) => changeMobileNo(e.target.value)}
            />
          </div>
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='d-flex flex-column justify-content-center align-items-center '>
          <button
            type='submit'
            id='kt_sign_in_submit'
            // className='border-0 fw-bolder me-4 rounded-pill ePulse-appColor-primary col-10 py-2'
            className={
              formik.values.mobileNumber.toString().length === 10
                ? 'ePulse-btn-primary col-10'
                : 'ePulse-button-disabled col-10'
            }
            disabled={formik.values.mobileNumber.toString().length !== 10 || loading}
          >
            <span className='indicator-label'>Reset MPIN</span>
            {loading && (
              <span className='indicator-progress'>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>

          <button
            type='button'
            id='kt_login_password_reset_form_cancel_button'
            className='border-0 rounded-pill btn-light-white fw-bolder col-10 py-2 mt-4 ePulse-textColor-primary'
            // disabled={formik.isSubmitting || !formik.isValid}
          >
            <Link to='/auth' className='ePulse-textColor-primary'>
              Go back to login
            </Link>
          </button>
        </div>
        {/* end::Form group */}
      </form>
    </>
  )
}
